import { useContext } from 'react'
import { ThemeContext } from '../../contexts/themeContext'

/**
 * Хук для использования контекста темы
 * @returns Контекст темы с функциями управления
 * @throws Ошибка, если хук используется вне ThemeProvider
 */
export function useTheme() {
  const context = useContext(ThemeContext)

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }

  return context
}
